import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'palantir-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class PalantirPageComponent {}
